var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8853 16.8008L29.6983 14.9802C29.5507 13.573 29.0168 11.6122 28.1533 9.53088C27.2922 7.44954 26.2835 5.68556 25.388 4.58585C24.2858 3.69525 22.5194 2.68903 20.4381 1.82795C18.3567 0.966879 16.3959 0.430553 14.9961 0.2854C13.5962 0.430553 11.6354 0.966879 9.55409 1.82795C7.47275 2.68903 5.70632 3.69771 4.60906 4.58831C3.71847 5.68556 2.70978 7.452 1.84871 9.53333C0.985173 11.6122 0.448847 13.573 0.301234 14.9802L0.114258 16.8008H29.8828H29.8853Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47131 6.30308C5.58333 5.40018 7.3719 4.38165 9.4803 3.50828C11.5887 2.6349 13.5741 2.09366 14.9936 1.94604C16.4132 2.09366 18.3986 2.63736 20.507 3.50828C22.6154 4.38165 24.4039 5.40018 25.5209 6.30308C26.4287 7.41509 27.4497 9.20367 28.3231 11.3121C29.1964 13.4205 29.7377 15.4059 29.8878 16.8303C29.7401 18.2548 29.1964 20.2402 28.3231 22.3486C27.4497 24.457 26.4287 26.2456 25.5209 27.3576C24.4039 28.258 22.6154 29.279 20.507 30.1524C18.3986 31.0257 16.4132 31.567 14.9936 31.7146C13.5741 31.567 11.5887 31.0257 9.4803 30.1524C7.3719 29.279 5.58333 28.2605 4.47131 27.3576C3.56841 26.2456 2.54743 24.457 1.67405 22.3486C0.800676 20.2402 0.259429 18.2548 0.111816 16.8303C0.259429 15.4059 0.803136 13.4205 1.67651 11.3121C2.54989 9.20367 3.57087 7.41509 4.47377 6.30308H4.47131Z",
    fill: "url(#paint0_radial_2007_1141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59692 8.42625C7.48506 7.70541 8.91198 6.89108 10.5948 6.19484C12.2775 5.4986 13.8619 5.0656 14.9961 4.94751C16.1278 5.0656 17.7146 5.4986 19.3974 6.19484C21.0802 6.89108 22.5071 7.70541 23.4002 8.42625C24.1235 9.31438 24.9378 10.7413 25.6365 12.4241C26.3327 14.1069 26.7657 15.6913 26.8863 16.8303C26.7682 17.9669 26.3352 19.5538 25.6365 21.2366C24.9403 22.9194 24.1259 24.3463 23.4002 25.2344C22.5071 25.9528 21.0802 26.7696 19.3974 27.4658C17.7146 28.1621 16.1302 28.5951 14.9961 28.7132C13.8644 28.5951 12.2775 28.1621 10.5948 27.4658C8.91198 26.7696 7.48506 25.9553 6.59692 25.2344C5.87608 24.3463 5.06175 22.9194 4.36551 21.2366C3.66927 19.5538 3.23627 17.9694 3.11572 16.8303C3.23381 15.6937 3.66681 14.1069 4.36551 12.4241C5.06175 10.7413 5.87608 9.31438 6.59692 8.42625Z",
    fill: "url(#paint1_radial_2007_1141)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1894 23.8715C13.7663 23.8715 13.3431 23.8666 12.9175 23.8617C12.4894 23.8568 12.0589 23.8519 11.6283 23.8519C11.5668 23.8519 11.5226 23.842 11.4684 23.8322L11.4045 23.8199C11.1511 23.7756 11.0822 23.6895 11.0822 23.4213C11.0822 23.1532 11.0871 22.8653 11.0896 22.5848C11.0945 22.3019 11.0969 22.019 11.0969 21.741C11.0969 21.2662 11.0797 20.7741 11.0625 20.319C11.0625 20.0705 11.0822 20.0016 11.0945 19.9844C11.0994 19.9844 11.1511 19.9573 11.3651 19.95L12.1647 19.9278C12.9692 19.9057 13.7294 19.886 14.5019 19.8319C14.9078 19.8023 15.2965 19.4579 15.3457 19.0741C15.3851 18.774 15.2153 18.5206 14.898 18.4099C14.3469 18.218 13.348 18.1663 12.9421 18.1515C12.6124 18.1417 12.6051 18.1171 12.6051 17.8219C12.5805 16.8427 12.6272 15.8857 12.6715 15.0615C12.6739 14.9877 12.6789 14.8745 12.6862 14.8057C12.7453 14.8007 12.8412 14.8007 12.9003 14.8007C12.9618 14.8007 13.38 14.8007 13.38 14.8007C14.3149 14.8007 15.2399 14.7515 15.358 14.166C15.3974 14.0553 15.3777 13.8978 15.2941 13.7527C15.1661 13.5337 14.9004 13.3689 14.5831 13.3074C14.0467 13.2065 13.4563 13.1942 13.0036 13.1942C12.7502 13.1942 12.4943 13.1991 12.2385 13.2041C11.99 13.209 11.7415 13.2139 11.498 13.2139H11.3995C11.3208 13.2139 11.2962 13.1991 11.2962 13.1991C11.2716 12.3184 11.2642 11.0834 11.2888 10.1805C11.2938 10.1337 11.3356 10.0993 11.5299 10.0919C12.8634 10.0378 14.2411 9.98364 15.5844 9.98364C15.887 9.98364 16.1896 9.9861 16.4897 9.99348C16.9965 9.99348 17.5821 10.0894 18.1454 10.2666C18.7851 10.4585 19.2845 10.8669 19.5921 11.4475C19.9291 12.0822 19.9931 12.8744 19.7618 13.6149C19.4346 14.6138 18.7802 15.0615 17.9536 15.6274L17.5796 15.8832L17.9782 16.0997C18.6941 16.4884 19.0336 16.6976 19.6314 17.5955C20.4064 18.7617 20.4802 20.1542 19.8332 21.4187C19.0926 22.8653 17.6091 23.7682 15.8624 23.8371C15.3679 23.8617 14.834 23.8715 14.1796 23.8715H14.1894Z",
    fill: "#7E967C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4595,
    y: 9.41528,
    width: 10.3919,
    height: 15.0565,
    fill: "url(#pattern0_2007_1141)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9961 28.0097C13.8521 27.8916 12.248 27.4537 10.548 26.75C8.84802 26.0464 7.40387 25.2223 6.50589 24.494C5.77767 23.5961 4.9535 22.1544 4.24988 20.4519C3.70371 19.1357 3.31992 17.8761 3.11572 16.8428C3.23627 17.9794 3.66927 19.5588 4.36305 21.2343C5.05929 22.917 5.87362 24.344 6.59446 25.2321C7.4826 25.9529 8.90952 26.7673 10.5923 27.4635C12.2751 28.1597 13.8595 28.5927 14.9936 28.7108C16.1253 28.5927 17.7122 28.1597 19.3949 27.4635C21.0777 26.7673 22.5047 25.9529 23.3977 25.2321C24.121 24.344 24.9353 22.917 25.634 21.2343C26.3278 19.5588 26.7608 17.9794 26.8814 16.8428C26.6796 17.8761 26.2934 19.1357 25.7497 20.4519C25.046 22.1519 24.2219 23.5961 23.4887 24.4916C22.5883 25.2198 21.1442 26.0415 19.4441 26.7451C17.7441 27.4487 16.1401 27.8867 14.9961 28.0072V28.0097Z",
    fill: "url(#paint2_radial_2007_1141)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67649 11.3119C2.54987 9.20351 3.57085 7.41494 4.47375 6.30292L4.60906 4.58569C3.71847 5.68295 2.70978 7.44938 1.84871 9.53072C0.985173 11.6121 0.448847 13.5728 0.301234 14.9801L0.114258 16.7982C0.266791 15.3762 0.808037 13.4031 1.67403 11.3095L1.67649 11.3119Z",
    fill: "url(#paint3_radial_2007_1141)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47119 6.30308C5.58321 5.40018 7.37178 4.38165 9.48018 3.50828C11.5886 2.6349 13.574 2.09366 14.9935 1.94604V0.2854C13.5937 0.430553 11.6329 0.966879 9.55153 1.82795C7.47019 2.68903 5.70376 3.69771 4.6065 4.58831L4.47119 6.30554V6.30308Z",
    fill: "url(#paint4_radial_2007_1141)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9961 1.94604C16.4156 2.09366 18.401 2.63736 20.5094 3.50828C22.6178 4.38165 24.4064 5.40018 25.5233 6.30308L25.388 4.58585C24.2859 3.69525 22.5194 2.68903 20.4381 1.82795C18.3567 0.966879 16.396 0.430553 14.9961 0.2854V1.94604Z",
    fill: "url(#paint5_radial_2007_1141)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5235 6.30292C26.4313 7.41494 27.4523 9.20351 28.3257 11.3119C29.1917 13.4056 29.7329 15.3762 29.8854 16.8006L29.6985 14.9801C29.5509 13.5728 29.017 11.6121 28.1535 9.53072C27.2924 7.44938 26.2837 5.68541 25.3882 4.58569L25.5235 6.30292Z",
    fill: "url(#paint6_radial_2007_1141)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3233 11.3121C27.4499 9.24797 26.429 7.4963 25.5211 6.40889C24.4042 5.52567 22.6156 4.52683 20.5072 3.67313C18.3988 2.81944 16.4134 2.28804 14.9939 2.14288C13.5744 2.28804 11.589 2.81698 9.48057 3.67313C7.37217 4.52683 5.58359 5.52567 4.47158 6.40889C3.56868 7.49876 2.54769 9.24797 1.67432 11.3121C2.54769 9.15941 3.56868 7.33393 4.47158 6.19977C5.58359 5.27965 7.37217 4.23652 9.48057 3.34593C11.589 2.45533 13.5744 1.90178 14.9939 1.75171C16.4134 1.90424 18.3988 2.45779 20.5072 3.34839C22.6156 4.23898 24.4042 5.27965 25.5211 6.20223C26.429 7.33639 27.4499 9.16187 28.3233 11.3146V11.3121Z",
    fill: "url(#paint7_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6343 21.2366C24.938 22.9636 24.1237 24.4275 23.3979 25.3377C21.447 26.9246 17.5131 28.5778 14.9939 28.8435C12.482 28.5803 8.5358 26.9246 6.59469 25.3377C5.87385 24.4275 5.05952 22.9612 4.36328 21.2366C5.05952 22.8751 5.87385 24.2626 6.59469 25.1286C8.5604 26.6933 12.5041 28.2875 14.9939 28.5409C17.491 28.2851 21.4224 26.6909 23.3979 25.1286C24.1212 24.2651 24.9356 22.8751 25.6343 21.239V21.2366Z",
    fill: "url(#paint8_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42845 11.9025C5.00529 12.6578 4.62888 13.4475 4.29921 14.2471C4.01875 14.9236 3.76781 15.6149 3.55377 16.3136C3.52425 16.4809 3.49964 16.6482 3.48242 16.8155C3.7186 17.9989 4.12454 19.1995 4.58706 20.3115C4.64364 20.4492 4.70269 20.587 4.76173 20.7223C5.66709 20.8626 6.59705 20.9364 7.54177 20.9364C14.7157 20.9364 20.9106 16.7392 23.8013 10.665C23.6931 10.51 23.5799 10.3599 23.4618 10.2148C22.9402 9.79899 22.3522 9.43242 21.7716 9.10521C21.0163 8.68205 20.2266 8.3081 19.4271 7.97597C18.6275 7.64385 17.8033 7.35108 16.9693 7.11736C16.3296 6.93777 15.658 6.78277 14.9987 6.71143C14.3369 6.78277 13.6652 6.93777 13.028 7.11736C12.194 7.35108 11.3723 7.64385 10.5703 7.97597C9.77072 8.3081 8.98099 8.68205 8.22571 9.10521C7.6451 9.42996 7.05957 9.79653 6.54046 10.2148C6.12223 10.7339 5.75566 11.3194 5.43091 11.9L5.42845 11.9025Z",
    fill: "url(#paint9_radial_2007_1141)"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5782 14.9753C18.4355 15.0787 18.2805 15.182 18.1182 15.2927C18.3027 15.4452 18.4872 15.5117 18.6397 15.6125C19.4049 16.1759 19.9215 16.8353 20.2241 17.529L19.8551 16.6803C19.5968 16.0701 19.181 15.4846 18.5782 14.9778V14.9753Z",
    fill: "url(#paint10_radial_2007_1141)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.118 15.2927C18.9939 14.6924 19.6827 14.2102 20.0345 13.1351C20.5217 11.5605 19.7984 9.91219 18.2361 9.43982C17.6973 9.27253 17.0749 9.15444 16.5041 9.15444C14.8558 9.12 13.1902 9.18888 11.5271 9.25531C11.1876 9.27007 11.0277 9.35372 11.0203 9.61204C10.9957 10.4879 11.0006 11.7401 11.04 12.6381C11.0498 12.8521 11.1852 12.9284 11.4066 12.9284C12.4497 12.9333 13.606 12.8448 14.5384 13.0194C14.9271 13.0932 15.1609 13.3491 15.0944 13.5484C14.9936 14.0478 13.4289 13.9469 12.9073 13.9642C12.4374 13.9642 12.4202 13.9814 12.403 14.4857C12.3513 15.4181 12.3119 16.3235 12.3365 17.2608C12.3365 17.716 12.4694 17.8513 12.9417 17.866C13.4904 17.8833 14.349 17.9448 14.814 18.1096C15.3675 18.304 14.9616 18.9608 14.4868 18.9928C13.4633 19.0642 12.4349 19.0765 11.3598 19.1109C10.8555 19.1281 10.7891 19.229 10.7891 19.7678C10.8063 20.2229 10.8235 20.7101 10.8235 21.18C10.8235 21.736 10.8063 22.3067 10.8063 22.8627C10.8063 23.2662 10.9736 23.4679 11.3623 23.5344C11.4632 23.5516 11.5296 23.5688 11.6305 23.5688C13.0598 23.5688 14.4892 23.6205 15.8842 23.5516C19.6015 23.4064 21.7272 19.6718 19.8722 16.882C19.235 15.9249 18.8463 15.6888 18.1205 15.2951L18.118 15.2927Z",
    fill: "url(#paint11_radial_2007_1141)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6871 18.2816C11.4042 18.2915 11.2714 18.3309 11.2099 18.4809L10.8408 19.3125C10.9072 19.1624 11.0524 19.1526 11.3575 19.1427C12.4326 19.1083 13.4609 19.0886 14.4844 19.0197C14.9568 18.9877 15.4439 18.4317 14.8534 18.1242C14.8387 18.1168 14.8214 18.1094 14.8042 18.1021C14.7501 18.1439 14.6517 18.1611 14.573 18.1709C13.6258 18.2201 12.6786 18.2546 11.6847 18.2866L11.6871 18.2816Z",
    fill: "url(#paint12_radial_2007_1141)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9049 13.9641C13.4265 13.9469 14.9912 14.0478 15.0921 13.5483C15.1437 13.3983 15.0232 13.2138 14.7919 13.1006C14.3097 13.2556 13.4634 13.2088 13.1165 13.2211C12.8484 13.2211 12.7401 13.2285 12.6909 13.3491L12.6811 13.3786L12.4375 14.1142C12.4842 13.9715 12.5999 13.9641 12.9049 13.9641Z",
    fill: "url(#paint13_radial_2007_1141)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.527 9.25531C13.1926 9.18888 14.8557 9.12 16.504 9.15444C17.0748 9.15444 17.6972 9.27253 18.236 9.43982C18.9839 9.6637 19.5375 10.1582 19.8622 10.7831L19.5621 10.1385C19.2668 9.50133 18.7453 9.00191 18.0392 8.77065C17.5422 8.60827 16.9665 8.49018 16.4401 8.49018C14.9172 8.4582 13.3795 8.52216 11.8419 8.58859C11.6107 8.59843 11.4753 8.64764 11.4138 8.77311L11.0596 9.43736C11.126 9.31189 11.2785 9.26269 11.527 9.25285V9.25531Z",
    fill: "url(#paint14_radial_2007_1141)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4958 13.0982C19.7787 12.178 19.5672 11.194 18.9054 10.5887C18.2067 9.95155 16.9913 9.86298 16.0909 9.85314C14.6763 9.83838 13.2641 9.89004 11.8519 9.94663C11.7019 9.95155 11.5813 10.0746 11.5789 10.2246C11.5666 10.8864 11.569 11.5556 11.5887 12.2174C11.5936 12.3724 11.7216 12.4954 11.8765 12.4929C12.7967 12.4782 13.7537 12.429 14.6418 12.5963C15.1757 12.6947 15.7563 13.1228 15.6628 13.7329C15.5152 14.7047 14.0981 14.6702 13.2395 14.6653C13.087 14.6653 12.9615 14.7834 12.9541 14.9359C12.9172 15.6838 12.8951 16.4145 12.9 17.1649C12.9 17.315 13.0181 17.438 13.1706 17.4478C13.7857 17.4798 14.4229 17.5069 15.001 17.7086C15.311 17.8168 15.557 18.0456 15.6284 18.3753C15.7735 19.0297 15.1585 19.6522 14.5262 19.6964C13.5642 19.7629 12.5949 19.7826 11.6305 19.8072C11.478 19.8121 11.355 19.9375 11.355 20.0901C11.355 20.8281 11.3648 22.169 11.3747 22.8308C11.3747 22.9808 11.4952 23.1038 11.6453 23.1112C12.5408 23.1506 15.2741 23.1407 15.8572 23.1161C16.8782 23.0743 17.8573 22.725 18.6323 22.0533C19.3064 21.4703 19.7861 20.6731 19.9337 19.7899C20.0789 18.919 19.8821 18.0604 19.3949 17.3273C18.679 16.2497 17.9951 15.9397 17.0282 15.4821C17.9803 14.9064 19.112 14.2471 19.4934 13.0957L19.4958 13.0982Z",
    fill: "url(#paint15_radial_2007_1141)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8496 9.94659C13.2617 9.89001 14.6764 9.83588 16.0885 9.8531C16.989 9.86294 18.2043 9.95151 18.903 10.5887C19.1269 10.7929 19.2991 11.0414 19.4172 11.3145L19.2376 10.8913C19.1244 10.6207 18.962 10.3771 18.7505 10.1754C18.0838 9.5382 16.925 9.44963 16.0664 9.44225C14.7182 9.42749 13.37 9.47915 12.0242 9.53574C11.9209 9.54066 11.8324 9.60462 11.7905 9.69565L11.5986 10.1114C11.6429 10.0179 11.7364 9.95151 11.8447 9.94659H11.8496Z",
    fill: "url(#paint16_radial_2007_1141)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6455 13.4009C15.4364 14.2792 14.1447 14.2472 13.3526 14.2423C13.232 14.2423 13.1262 14.3259 13.0918 14.4415L12.9663 14.8598C13.0032 14.7466 13.1115 14.6654 13.2369 14.6654C14.0955 14.6703 15.5151 14.7048 15.6602 13.733C15.6775 13.6149 15.6701 13.5042 15.643 13.4009H15.6455Z",
    fill: "url(#paint17_radial_2007_1141)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5801 19.261C13.6625 19.3275 12.7399 19.3471 11.8198 19.3717C11.714 19.3742 11.6254 19.4406 11.5836 19.5317L11.3818 19.972C11.4261 19.8761 11.5221 19.8097 11.6328 19.8072C12.5972 19.7801 13.5665 19.7629 14.5284 19.6965C15.1607 19.6522 15.7733 19.0298 15.6306 18.3754C15.6306 18.3704 15.6306 18.3655 15.6282 18.3606C15.515 18.8403 15.0549 19.229 14.5826 19.2635L14.5801 19.261Z",
    fill: "url(#paint18_radial_2007_1141)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0308 15.4846C17.9976 15.9397 18.6816 16.2522 19.3975 17.3297C19.4664 17.4331 19.5303 17.5388 19.5869 17.6471C19.4959 17.3888 19.3753 17.1378 19.2228 16.8992C18.6496 15.9963 18.096 15.6322 17.385 15.2681C17.2645 15.3419 17.1464 15.4132 17.0308 15.4846Z",
    fill: "url(#paint19_radial_2007_1141)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7658 10.2296C11.7535 10.8914 11.756 11.5507 11.7757 12.2125C11.7757 12.2642 11.8199 12.306 11.8716 12.3035C12.8016 12.2888 13.7561 12.2371 14.6738 12.4093C14.8485 12.4413 15.0207 12.5053 15.1781 12.5889C15.6136 12.8251 15.926 13.2458 15.8498 13.76C15.8202 13.9617 15.7391 14.1462 15.6037 14.2988C15.0896 14.8867 13.9579 14.8572 13.237 14.8523C13.1854 14.8523 13.1435 14.8917 13.1411 14.9433C13.1042 15.6814 13.082 16.4219 13.087 17.16C13.087 17.2092 13.1263 17.251 13.178 17.2535C13.8103 17.2855 14.4573 17.315 15.0625 17.5266C15.2692 17.5979 15.4488 17.716 15.5841 17.8734C16.6493 17.6127 17.6457 17.1797 18.5412 16.604C18.3838 16.4613 18.214 16.3309 18.0221 16.2103C17.6826 15.9963 17.3111 15.8265 16.947 15.6543L16.6272 15.5043L16.9298 15.3222C17.8524 14.7637 18.9521 14.1265 19.3113 13.0416C19.5573 12.2371 19.4122 11.3096 18.775 10.729C18.1205 10.1312 16.9323 10.0524 16.086 10.0426C14.6762 10.0278 13.2641 10.0795 11.8568 10.1361C11.8052 10.1361 11.7658 10.1779 11.7658 10.2296Z",
    fill: "url(#paint20_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9068 20.8625C15.7393 20.8625 13.7564 21.6449 12.2188 22.939C12.3147 22.939 12.4131 22.9414 12.5091 22.9439C12.8928 22.9488 13.2791 22.9513 13.6629 22.9513C14.1057 22.9513 14.5486 22.9513 14.9914 22.9463C15.2768 22.9439 15.5646 22.9414 15.8476 22.9316C16.8243 22.8922 17.7641 22.5576 18.507 21.9155C18.8195 21.6449 19.0877 21.3275 19.2992 20.9757C18.8441 20.9044 18.3791 20.865 17.9043 20.865L17.9068 20.8625Z",
    fill: "url(#paint21_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7146 9.78431C15.1612 9.74987 15.5327 9.78431 15.5327 9.85074C15.5327 9.91716 15.2104 9.97867 13.7146 10.0131C12.2188 10.0476 11.8965 10.0082 11.8965 9.94669C11.8965 9.88518 12.268 9.81875 13.7146 9.78677V9.78431Z",
    fill: "url(#paint22_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0835 9.04378C16.0123 9.00196 16.5068 9.061 16.5068 9.14711C16.5068 9.23322 16.0762 9.30949 14.0835 9.35377C12.0932 9.39559 11.6602 9.33655 11.6602 9.25044C11.6602 9.16433 12.1547 9.08561 14.0835 9.04378Z",
    fill: "url(#paint23_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7892 19.6646C13.67 19.6351 13.9037 19.6745 13.9037 19.731C13.9037 19.7876 13.6995 19.8417 12.7892 19.8713C11.8789 19.9008 11.6821 19.8614 11.6821 19.8048C11.6821 19.7483 11.9085 19.6941 12.7892 19.6646Z",
    fill: "url(#paint24_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8975 18.9607C14.1227 18.9139 14.4376 18.9533 14.4376 19.0173C14.4376 19.0812 14.1645 19.1476 12.8975 19.1969C11.6305 19.2461 11.3574 19.2042 11.3574 19.1378C11.3574 19.0714 11.6723 19.0074 12.8975 18.9582V18.9607Z",
    fill: "url(#paint25_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4387 14.2029C15.4387 14.2644 15.2173 14.5374 14.5604 14.6654C14.0093 14.7736 13.2368 14.7293 13.2368 14.6654C13.2368 14.6014 14.0044 14.6014 14.5555 14.4981C15.1066 14.3948 15.4362 14.1414 15.4362 14.2029H15.4387Z",
    fill: "url(#paint26_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1018 13.445C15.1584 13.5188 15.1362 13.8608 14.3121 13.9813C13.7241 14.0674 12.7695 14.0256 12.772 13.9592C12.7744 13.9051 13.5838 13.9223 14.2973 13.8165C14.9714 13.7156 15.06 13.3909 15.0993 13.445H15.1018Z",
    fill: "url(#paint27_radial_2007_1141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4298 7.64634C12.1765 6.92304 13.8224 6.47528 14.9959 6.35227C16.1719 6.47528 17.8178 6.9255 19.5621 7.64634C21.3088 8.36965 22.7899 9.2135 23.7149 9.9614C24.4653 10.8815 25.3116 12.3626 26.0349 14.1093C26.34 14.8425 26.5958 15.5608 26.7976 16.2325C26.6131 15.1672 26.2145 13.8313 25.6339 12.4265C24.9376 10.7437 24.1233 9.31683 23.3976 8.42869C22.5045 7.70785 21.0776 6.89352 19.3948 6.19728C17.712 5.50104 16.1276 5.06804 14.9935 4.94995C13.8618 5.06804 12.2749 5.50104 10.5922 6.19728C8.90937 6.89352 7.48245 7.70785 6.59431 8.42869C5.87347 9.31683 5.05914 10.7437 4.3629 12.4265C3.78229 13.8313 3.38373 15.1672 3.19922 16.2325C3.40342 15.5608 3.65928 14.8449 3.96188 14.1093C4.68519 12.3626 5.5315 10.8815 6.2794 9.9614C7.20198 9.2135 8.68303 8.36965 10.4298 7.64634Z",
    fill: "url(#paint28_radial_2007_1141)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2007_1141",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2007_1141",
    transform: "scale(0.00578035 0.00392157)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.81589 3.30162) scale(31.4144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5520F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5259 5.74708) scale(28.4056 28.4056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2B2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9473 29.2176) scale(17.8292 17.8291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AC600F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8C430A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803808"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3185 14.0058) scale(19.1527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CA7520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AA591C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E4F1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8874 -0.671621) scale(20.0679 20.0679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CA7520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AA591C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E4F1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8878 5.95373) scale(28.0661 28.0661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AC600F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8C430A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803808"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.477 12.6503) scale(18.3876 18.3876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AC600F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8C430A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803808"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4414 2.92277) scale(26.0315 26.0315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4B46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#454022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#111608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.201 28.9026) scale(22.7053 22.7053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4B46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#454022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#111608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.14944 2.33963) scale(24.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1552 17.1329) scale(3.06296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AC600F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8C430A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803808"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4509 9.19626) scale(15.6297 15.6297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C26B2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8482 18.7368) scale(5.16644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AC600F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8C430A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803808"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5851 14.0822) scale(4.52187 4.52187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AC600F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8C430A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803808"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3597 8.58121) scale(11.1644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CA7520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AA591C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E4F1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.686 9.17412) scale(17.4011 17.4011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9775 9.69073) scale(12.7439 12.7439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3722 14.0627) scale(3.79365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.709 17.6914) scale(4.9032 4.9032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6397 18.5426) scale(3.57715 3.57715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2726 8.53448) scale(14.7662 14.7662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8785 27.1927) scale(10.3723 10.3722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0072 9.43004) scale(7.90712 7.90712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90FF7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1683 8.18025) scale(13.8953 13.8953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4B46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#454022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#111608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1399 19.8713) scale(6.20219 6.20221)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90FF7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4573 19.8611) scale(10.3107 10.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4B46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#454022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#111608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4313 14.717) scale(3.48612 3.48612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90FF7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9296 14.6825) scale(6.37195 6.37194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4B46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#454022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#111608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2007_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7278 16.4883) scale(13.6123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F9FAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E8ECE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDD6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A8B8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E967C"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2007_1141",
    width: 173,
    height: 255,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop3);
export default __webpack_public_path__ + "static/media/top3.1d5b791bb00dccfd39eeb8b8bfce12e3.svg";
export { ForwardRef as ReactComponent };